import { render, staticRenderFns } from "./ViewBusinessesTable.vue?vue&type=template&id=50226d40"
import script from "./ViewBusinessesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBusinessesTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports